// extracted by mini-css-extract-plugin
export default {"dot":"Dot_dot__afXSX","default":"Dot_default__6rOqr"};